import React from "react";
import Navbar from "../components/mainNavBar";
import HomeFooter from "../components/homefooter";

export default function Privacy() {
  return (
    <>
      <Navbar />

      <main className="pagebg privacy-page">
        <section className="privacy-header">
          <h1>Privacy Policy</h1>
          <p>
            At Generative Insight, we respect your privacy and are committed to
            protecting your personal data. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information when you
            visit our website or use our research platform.
          </p>
        </section>
        <section className="privacy-table">
          <div className="privacy-row">
            <div className="left-title">Information We Collect</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>
                We collect information to deliver, improve, and secure our
                services. The types of information we may collect include:
              </p>
              <h4>A. Information You Provide to Us</h4>
              <ul>
                <li>Name, company, email address, and contact details</li>
                <li>Payment and billing details</li>
                <li>
                  Research project inputs (survey questions, parameters, files)
                </li>
              </ul>
              <h4>B. Automatically Collected Information</h4>
              <ul>
                <li>Log data (browser, OS, IP, access times)</li>
                <li>Website usage data (pages visited, interactions)</li>
                <li>Cookies and tracking data</li>
              </ul>
              <h4>C. Data From Third Parties</h4>
              <ul>
                <li>Analytics and authorized partners</li>
              </ul>
            </div>
          </div>
          {/* ROW 2 */}
          <div className="privacy-row">
            <div className="left-title">How We Use Your Information</div>

            <div className="right-content">
              <p style={{marginTop:"0px"}}>Generative Insight uses collected data to:</p>

              <h4>A. Information You Provide to Us</h4>
              <ul>
                <li>Deliver research projects and insights</li>
                <li>Communicate about projects and subscriptions</li>
                <li>Improve platform performance and analytics</li>
                <li>Comply with legal obligations</li>
              </ul>
              <p>
                We never sell your data. Any data used for analytics is
                aggregated and anonymized before processing.
              </p>
            </div>
          </div>

          {/* ROW 3 */}
          <div className="privacy-row">
            <div className="left-title">Data Security</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>
                We use administrative, technical, and physical safeguards to
                protect your data.
              </p>
              <ul>
                <li>All data transfers use SSL encryption</li>
                <li>Data stored in secure access-controlled environments</li>
                <li>Only authorized personnel access user data</li>
              </ul>
              <p>
                No system is entirely secure; we encourage using strong
                passwords.
              </p>
            </div>
          </div>

          {/* ROW 4 */}
          <div className="privacy-row">
            <div className="left-title">Data Retention</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>We retain data only as long as necessary to:</p>
              <ul>
                <li>Deliver your projects</li>
                <li>Comply with legal requirements</li>
                <li>Improve performance and analytics</li>
              </ul>
              <p>
                You may request deletion anytime by emailing
                privacy@generativeinsight.ai.
              </p>
            </div>
          </div>

          {/* ROW 5 */}
          <div className="privacy-row">
            <div className="left-title">Sharing and Disclosure</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>We may share information:</p>

              <ul>
                <li>With service providers (hosting, payments, analytics)</li>
                <li>To comply with law/regulation</li>
                <li>During mergers or acquisitions</li>
              </ul>

              <p>You may request deletion anytime.</p>
            </div>
          </div>

          {/* ROW 6 */}
          <div className="privacy-row">
            <div className="left-title">Cookies and Tracking</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>We use cookies to:</p>
              <ul>
                <li>Maintain session functionality</li>
                <li>Measure usage and performance</li>
                <li>Personalize user experience</li>
              </ul>
              <p>You can disable cookies in browser settings.</p>
            </div>
          </div>

          {/* ROW 7 */}
          <div className="privacy-row">
            <div className="left-title">International Transfers</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>
                If you access our platform outside the U.S., your data may be
                transferred to the U.S. and handled under U.S. data laws.
              </p>
            </div>
          </div>

          {/* ROW 8 */}
          <div className="privacy-row">
            <div className="left-title">Updates to This Policy</div>
            <div className="right-content">
              <p style={{marginTop:"0px"}}>
                We may periodically update this Privacy Policy. Check this page
                regularly for updates.
              </p>
            </div>
          </div>
        </section>
      </main>

      <HomeFooter />
    </>
  );
}
